import { FC } from 'react';
import { Button, SxProps, Theme } from '@mui/material';
import { Resource } from '@api/resources';
import { useResourceLoading } from '@api/utils/ApiLoadingStore';

interface Props {
  className?: string;
  sx?: SxProps<Theme>;
  variant?: 'text' | 'outlined' | 'contained';
  color?: 'inherit' | 'error' | 'primary' | 'secondary' | 'success' | 'info' | 'warning';
  type?: 'submit' | 'reset' | 'button';
  loading?: boolean;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  children: React.ReactNode;
  /**
   * Resource or array of resources to track loading state for.
   * Button shows loading if ANY specified resource is loading.
   * If both `loading` and `resourceLoading ` are provided, the button loads if EITHER is true.
   */
  resourceLoading?: Resource | Resource[];
}

export const QcsLoadingButton: FC<Props> = ({
  className,
  sx,
  variant,
  color,
  type = 'button',
  loading,
  disabled,
  onClick,
  children,
  resourceLoading,
}) => {
  const resourcesAreLoading = useResourceLoading(resourceLoading);

  return (
    <Button
      className={className}
      sx={sx}
      variant={variant}
      color={color}
      type={type}
      loading={loading || resourcesAreLoading}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};
